import { Controller } from "stimulus";
import CookieDent from "../../assets/cookie-searchfilter";
import { parseQuery, buildQuery } from "../../assets/url";

export default class extends Controller {
    static targets = ["sort", "filter", "status"];

    _removeParameter(url, param) {
        let url_parts = url.split("?", 2);

        // aus Pfad entfernen
        const expr = new RegExp(`/${param}/[^/]+`)
        url_parts[0] = url_parts[0].replace(expr, "");

        // aus Querystring entfernen
        let query = parseQuery(url_parts[1] || "");
        delete query[param];
        url_parts[1] = buildQuery(query);

        return url_parts[1] ? url_parts.join("?") : url_parts[0];
    }

    _sortChange(cookie) {
        var url = location.href;
        url = this._removeParameter(url, 'sortby');
        url = this._removeParameter(url, 'sort');

        const [sortby, sort] = this.sortTarget.value.split('#');
        if (sortby == 'standard') {
            cookie.setValue("sortby", '');
            cookie.setValue("sort", '');
        } else {
            cookie.setValue("sortby", sortby);
            cookie.setValue("sort", sort);
        }

        location.href = url;
    }

    onSortChange() {
        let cookie = new CookieDent('search-filter');
        this._sortChange(cookie);
        return false;
    }

    onSortChangeMachinelist() {
        let cookie = new CookieDent('machinelist-filter');
        this._sortChange(cookie);
        return false;
    }

    onResultChange(event) {
        let results = event.target.value;
        let url = this._removeParameter(location.href, 'results');

        const cookie = new CookieDent('search-filter');
        cookie.setValue('results', results);

        location.href = url;
        return false;
    }

    onStatusChange(event) {
        let cookie = new CookieDent('machinelist-filter');
        let status_value_array = event.target.value.split('#');
        let field = status_value_array[0];
        let value = status_value_array[1];
        let url = location.href;

        // Status und Export schließen sich gegenseitig aus. Jeweils das andere entfernen.
        let reset_field = null;
        if (field == 'status') {
            reset_field = 'exportinterface';
        } else if (field == 'exportinterface') {
            reset_field = 'status';
        }

        let field_regex = new RegExp("\/" + field + "\/\\w+");
        if (url.match(field_regex)) {
            url = url.replace(field_regex, "/" + field + "/" + value);
        } else {
            url += field + "/" + value + "/";
        }

        // Gegenteiligen Wert entfernen.
        let reset_field_regex = new RegExp("\/" + reset_field + "\/\\w+");
        if (url.match(reset_field_regex)) {
            url = url.replace(reset_field_regex, "");
        }

        cookie.setValue(field, value);
        cookie.setValue(reset_field, '');
        location.href = url;
        return false;
    }

    onFilterReset(event) {
        const cookie = new CookieDent('machinelist-filter');
        cookie.delete();
    }

    onFilterClick() {
        this.setFilter();
    }


    onFilterInput(event) {
        if (event.keyCode == 13) {
            this.setFilter();
        }
    }

    setFilter() {
        let cookie = new CookieDent('machinelist-filter');
        let filter_value = this.filterTarget.value;
        cookie.setValue('filter', filter_value);
        window.location.reload();
    }

    filterMobile() {
        let cookie = new CookieDent('machinelist-filter');
        let filter = this.filterTarget.value;
        let status_value = this.statusTarget.value.split('#');
        cookie.setValue('filter', filter);
        cookie.setValue(status_value[0], status_value[1]);
        let reset_param_name = 'status';
        if (status_value['0'] == 'status') {
            reset_param_name = 'exportinterface';
        }
        cookie.setValue(reset_param_name, "");
        window.location.reload();
    }

}
